module.exports = __webpack_public_path__ + "static/media/tombstone-alt.cef45f8d.svg";